import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { inject } from '@angular/core';
import { catchError, map, of } from 'rxjs';

import { UserService } from '../../services/user/user.service';

/**
 * Blocks unverified accounts from the app - the hard email-verification gate.
 * Redirects to the verification screen, preserving the attempted URL so the
 * user continues there once verified. Runs after authGuard (token is valid).
 */
export const verifiedGuard: CanActivateFn = (route, state) => {
  const userService = inject(UserService);
  const router = inject(Router);

  return userService.getCurrentUser().pipe(
    map((user) =>
      user.isVerified
        ? true
        : new RedirectCommand(
            router.createUrlTree(['/verify-email'], {
              queryParams: { returnUrl: state.url },
            }),
          ),
    ),
    catchError(() => of(new RedirectCommand(router.parseUrl('/auth/login')))),
  );
};

/**
 * Guards the verification screen itself: only an authenticated, still-unverified
 * user belongs there. Verified users are sent to the app.
 */
export const unverifiedGuard: CanActivateFn = () => {
  const userService = inject(UserService);
  const router = inject(Router);

  return userService.getCurrentUser().pipe(
    map((user) => (user.isVerified ? new RedirectCommand(router.parseUrl('/')) : true)),
    catchError(() => of(new RedirectCommand(router.parseUrl('/auth/login')))),
  );
};
